<div class="argin-top margin-bottom-large relative">
  <div class="summary-form text-align-right">
    <span class="bold minor-margin-right">Organization:</span>{{organization?.name}} <br />
    <span class="bold minor-margin-right">Issue Type:</span>{{selectedIssueType?.description}}<br />
    <span class="bold minor-margin-right">API #:</span>{{selectedWell?.id}}
  </div>
  <div class="grid-container wrapper">
    <form [formGroup]="form">
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 medium-12 large-12">
          @if (formErrors?.length > 0) {
            <div class="form-errors">
              <ul style="list-style-type: none;">
                @for (error of formErrors; track error) {
                  <li>{{error}}</li>
                }
              </ul>
            </div>
          }
        </div>

        <div class="cell small-12 large-12 medium-12">
          <div class="grid-x grid-margin-x">
            <div class="cell small-12 medium-12 large-12 bold text-align-center">
              Search for Organization
            </div>
            <div class="cell small-4 large-4 medium-4 bold text-align-right">
              RICS Owner #:<span [ngClass]="{ 'red': form?.get('organizationFound')?.invalid }">*</span>
            </div>
            <div class="cell small-6 large-4 medium-4">
              <input type="text" formControlName="ricsNumber" />
            </div>
            <div class="cell small-2 large-4 medium-4">
              <button class="button" (click)="searchOrganization('rics')">
                <svg-icon icon="icon-data-lookup" class="small black"></svg-icon>
              </button>
            </div>
            <div class="cell small-4 large-4 medium-4 bold text-align-right">
              RBDMS Owner #:<span [ngClass]="{ 'red': form?.get('organizationFound')?.invalid }">*</span>
            </div>
            <div class="cell small-6 large-4 medium-4">
              <input type="text" formControlName="rbdmsNumber" />
            </div>
            <div class="cell small-2 large-4 medium-4">
              <button class="button" (click)="searchOrganization('rbdms')">
                <svg-icon icon="icon-data-lookup" class="small black"></svg-icon>
              </button>
            </div>
            <div class="cell small-4 large-4 medium-4 bold text-align-right">
              Owner Name:<span [ngClass]="{ 'red': form?.get('organizationFound')?.invalid }">*</span>
            </div>
            <div class="cell small-6 large-4 medium-4">
              <input type="text" formControlName="ownerName" />
            </div>
            <div class="cell small-2 large-4 medium-4">
              <button class="button" (click)="searchOrganization('name')">
                <svg-icon icon="icon-data-lookup" class="small black"></svg-icon>
              </button>
            </div>
            <div class="cell small-12 medium-12 large-12">
              <text-loader [run]="searchingOrganizations?.value" [text]="'Searching'" [tickType]="'.'" [interval]="1000"></text-loader>
            </div>
            @if (organizationSearchRun?.value) {
              <div class="cell small-2 large-3 medium-3 text-align-right">
                Select an Organization:<help-text [helpText]="organizationSearchHelp"></help-text>
              </div>
              <div class="cell large-6 medium-6 small-10">
                <ag-grid-angular class="data-grid " [gridOptions]="organizationGridOptions" [rowData]="organizationData | async" rowSelection="single" (selectionChanged)="onOrganizationGridSelecting($event)" aria-label="Create Issue"></ag-grid-angular>
              </div>
              <div class="cell small-2 large-3 medium-3">
                <button class="button" (click)="reset()">Reset</button>
              </div>
            }
          </div>
        </div>
        <div class="cell small-12 large-12 medium-12">
          <div class="grid-x grid-margin-x">
            <div class="cell small-6 medium-4 large-4 bold padding-right text-align-right">
              Select Issue Type:<span [ngClass]="{ 'red': form?.get('issueType')?.invalid }">*</span>
            </div>
            <div class="cell small-6 medium-8 large-8">
              <text-loader [run]="typesLoading?.value" [tickType]="'.'" [interval]="1000" [text]="'Loading Issue Types'"></text-loader>
              @if (typesLoading?.value == false) {
                <ng-select formControlName="issueType" [items]="issueTypes" bindValue="id" bindLabel="description" [placeholder]="" (ngModelChange)="issueTypeChanged($event)"></ng-select>
              }
            </div>
          </div>
        </div>
        @if (wellRequired) {
          <div class="cell small-12 large-12 medium-12">
            <div class="grid-x grid-margin-x">
              <div class="cell small-12 medium-12 large-12">
                <span class="bold margin-right">
                  Issue applies to a well.  Search for wells owned by the selected organization and select one.
                </span>
                <span class="margin-left">
                  <button class="button" (click)="searchWells()">
                    Search for Wells
                  </button>
                </span>
              </div>
              @if (wellSearchRun?.value) {
                <div class="cell small-2 large-3 medium-3 text-align-right">
                  Select a Well:<span [ngClass]="{ 'red': form?.get('apiNumber')?.invalid }">*</span>
                </div>
                <div class="cell small-10 medium-9 large-9">
                  <ag-grid-angular class="data-grid " [gridOptions]="wellGridOptions" [rowData]="wellData | async" rowSelection="single" (selectionChanged)="onWellGridSelecting($event)" aria-label="Create Issue"></ag-grid-angular>
                </div>
              }
            </div>
          </div>
        }
        @if (isAnnual) {
          <div class="cell small-12 medium-12 large-12">
            <div class="grid-x grid-margin-x">
              <div class="cell small-6 medium-8 large-8 text-align-right">
                Applicable Reporting Year:<span [ngClass]="{ 'red': form?.get('reportingYear')?.invalid }" class="bold">*</span>
              </div>
              <div class="cell small-6 medium-4 large-4">
                <input type="number" min="2000" max="2100" formControlName="reportingYear" />
              </div>
              @if (isQuarterly || relatedComplianceType?.typeId == 'PREP') {
                <div class="cell small-6 medium-8 large-8 text-align-right">
                  Applicable Reporting Quarter:<span [ngClass]="{ 'red': form?.get('reportingQuarter')?.invalid }" class="bold">*</span>
                </div>
                <div class="cell small-6 medium-4 large-4">
                  <select formControlName="reportingQuarter">
                    @for (qtr of quarters; track qtr) {
                      <option [ngValue]="qtr">{{qtr}}</option>
                    }
                  </select>
                </div>
              }
            </div>
          </div>
        }
        <div class="cell small-12 large-12 medium-12">
          <div class="grid-x grid-margin-x">
            <div class="cell small-6 medium-4 large-4 bold text-align-right">
              Issue was / will be due on:<span [ngClass]="{ 'red': form?.get('dueDate')?.invalid }">*</span>
            </div>
            <div class="cell small-6 medium-4 large-4">
              <common-date-picker [id]="'dueDate'" [initialDate]="form?.get('dueDate')?.value" (dateUpdated)="dueDateChanged($event)"></common-date-picker>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="cell large-12 medium-12 small-12 text-align-center">
      <span class="margin-right">
        <button class="button" (click)="create()" [disabled]="form?.invalid">Create</button>
      </span>
      <span class="margin-left">
        <button class="button" (click)="cancel()">Cancel</button>
      </span>
    </div>
  </div>
</div>

